export default [
  {
    path: "/order/list/:type?",
    name: "MyOrder",
    meta: {
      title: "My order",
      keepAlive: false,
      // auth: true,
      footer: true,
    },
    component: () => import("@views/order/MyOrder")
  },
  {
    path: "/order/logistics/:id",
    name: "Logistics",
    meta: {
      title: "Tracking information",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/Logistics")
  },
  {
    path: "/order/detail/:id",
    name: "OrderDetails",
    meta: {
      title: "Order detail",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/OrderDetails")
  },
  {
    path: "/order/submit/:id",
    name: "OrderSubmission",
    meta: {
      title: "Submit order",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/OrderSubmission")
  },
  {
    path: "/order/status/:id/:status",
    name: "PaymentStatus",
    meta: {
      title: "Payment status",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/PaymentStatus")
  },
  {
    path: "/order/refund/:id",
    name: "GoodsReturn",
    meta: {
      title: "Apply for refund",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/GoodsReturn.vue")
  },
  {
    path: "/order/refund_list",
    name: "ReturnList",
    meta: {
      title: "List of refunds",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/ReturnList.vue")
  }
  ,
  {
    path: "/order/game/likeNum",
    name: "likeNum",
    meta: {
      title: "game",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/game/likeNum.vue")
  } ,
  {
    path: "/order/game/number",
    name: "Guess numbers",
    meta: {
      title: "BULLS-EYE",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/game/number.vue")
  } ,
  {
    path: "/order/integral/submit/:id",
    name: "integralOrderSubmission",
    meta: {
      title: "Order for points",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/integral/OrderSubmission.vue")
  }
  ,
  {
    path: "/order/integral/PaymentStatus/:id",
    name: "integralOrderPaymentStatus",
    meta: {
      title: "Order for points status",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/integral/PaymentStatus.vue")
  },
  {
    path: "/order/integral/list/:type",
    name: 'integralOrderList',
    meta: {
      title: "My order for points",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/integral/MyOrder.vue")
  },
  {
    path: "/order/integral/details/:id",
    name: 'integralOrderdetails',
    meta: {
      title: "Details of points order",
      keepAlive: true,
      auth: true,
    },
    component: () => import("@views/order/integral/OrderDetails.vue")
  },


];
